/**
 * **Which of the two endings a running plan is offered** — one rule, one place, because both of them
 * are irreversible and they are not the same act.
 *
 * `end-early` cancels what is left; `complete` declares the plan finished. They write different
 * statuses and they cannot both be true. The backend's rule is "exactly one of the two, never both",
 * and until 17 September 2026 this app made that choice twice: the calendar's plan menu from its
 * grid, the builder's from the assignment summary's counts. The two disagreed on a real plan — one
 * whose last session has passed with a skip still unfinished — and they disagreed one click apart,
 * on the same assignment, with no way for a trainer to tell which surface was right.
 *
 * So the DECISION lives here and the two surfaces hand it one named fact. Each still answers that
 * fact from what it can see, and the point of naming it is that they are now answering the same
 * QUESTION: is there still plan ahead of this client?
 *
 * · The calendar reads its own grid — sessions dated after today, or a cursor with cycles to go.
 * · The builder reads the assignment summary: `nextWorkoutDate` still ahead of today for a dated
 *   plan, and the workout counts for a self-paced one, whose `nextWorkoutDate` is always null by
 *   construction (the roll-up gates it: an undated plan mints a row only for an occurrence the
 *   client has lived, so its earliest unfinished row is the oldest SKIP, behind the cursor).
 *
 * No React, no DOM, no query hook, no i18next.
 */

/** The two irreversible endings, in this app's vocabulary. */
export type PlanEnding = 'endEarly' | 'complete';

/**
 * @param hasPlanLeft whether the client still has plan ahead of them. The one fact this turns on.
 */
export function planEnding(hasPlanLeft: boolean): PlanEnding {
  return hasPlanLeft ? 'endEarly' : 'complete';
}
